import { getConsentParameterValue } from "./helper.utils";

export const getOtpPageHeading = (variableList = [],t) => {
    if(global?.alternativeText?.CUSTOM_OTP_PAGE_HEADING){
        return getDisplayText(global.alternativeText.CUSTOM_OTP_PAGE_HEADING, variableList);
    }
    else if(global?.institutionType === 'LSP'){
        return (t('login.titles.accountInfoRequired'));
    }
    return `${global.entityName} ${ (t('login.titles.requiresAccountInfo'))}`;
}

export const getOtpPageSubHeading = (reviewConsentParams, consentDetailList,t) => {
    if(global?.alternativeText?.CUSTOM_OTP_PAGE_SUBHEADING){
        if(reviewConsentParams && consentDetailList){
            return global?.alternativeText?.CUSTOM_OTP_PAGE_SUBHEADING + " " + getConsentParameterValue(reviewConsentParams, consentDetailList[0]);
        }
        else{
            return global?.alternativeText?.CUSTOM_OTP_PAGE_SUBHEADING;
        }
    }
    return t('login.messages.proceedWithSharing');
}

export const getDisplayText = (customHeading, variableList) => {
    let displayText = customHeading;
    let numberOfVariables = customHeading.match(/{#var#}/g)?.length;
    if(numberOfVariables !== variableList.length){
        console.warn('Number of variables in custom heading and variable list do not match');
    }
    for(let i = 0; i < numberOfVariables; i++){
        displayText = displayText.replace(`{#var#}`, variableList[i]);
    }
    return displayText;
}